import React, { forwardRef } from "react";
import classnames from "classnames";
import styled from "styled-components";

import { LoadingIndicator } from "@formant/ui/component/common/LoadingIndicator";

import rightArrow from "../../static/images/right-arrow.svg";
import { Button, ButtonProps } from "./Button";
import styles from "./StandardButton.module.scss";

export interface IStandardButtonProps extends ButtonProps {
    arrow?: boolean;
    critical?: boolean;
    dark?: boolean;
    hotkey?: string;
    id?: string;
    large?: boolean;
    lighter?: boolean;
    loading?: boolean;
    primary?: boolean;
    subtle?: boolean;
    blue?: boolean;
    minimal?: boolean;
}

const RightArrow = styled.img`
    margin-left: 0.625rem;
    width: 2.5rem;
    height: 0.8125rem;
`;

export const StandardButton = forwardRef<
    HTMLButtonElement & HTMLAnchorElement,
    IStandardButtonProps
>(function StandardButton(props, ref) {
    const {
        arrow,
        critical,
        dark,
        large,
        lighter,
        loading,
        primary,
        subtle,
        blue,
        minimal,
        className,
        children,

        ...rest
    } = props;

    return (
        <Button
            className={classnames(
                styles["standard-button"],
                primary && styles.primary,
                large && styles.large,
                lighter && styles.lighter,
                subtle && styles.subtle,
                dark && styles.dark,
                loading && styles.loading,
                critical && styles.critical,
                minimal && styles.minimalist,
                blue && styles.blue,
                className,
            )}
            ref={ref}
            {...rest}
        >
            {children}
            {arrow && (
                <RightArrow
                    className={styles["right-arrow"]}
                    src={rightArrow}
                    width="212px"
                    height="318px"
                    alt="Views"
                />
            )}
            {loading !== undefined && <LoadingIndicator visible={loading} />}
        </Button>
    );
});

StandardButton.displayName = "StandardButton";
